import React from "react";

interface IProps {
  loading: boolean;
}

const ProfileFilters: React.FC<IProps> = () => {
  return null;
};

export default ProfileFilters;
